<template>
  <div class="collectWrap">
    <div class="tab">
      <span :class="activeTab==1?'activeTab':''"
            @click="tab(1)">会议</span>
      <span :class="activeTab==2?'activeTab':''"
            @click="tab(2)">单课</span>
    </div>
    <div class="container"
         v-if="containerList.length">
      <!-- <i-videolist :video_newest="containerList"></i-videolist> -->
      <div class="container_item"
           v-for="(item) in containerList"
           :key="item.vId"
           v-show="item.vFl==1"
           @click="toDetails(item)">
        <div class="item_con">
          <div style="width: 2.84rem;height: 1.6rem;position: absolute;z-index: 1;background: rgba(0,0,0,0.3);border: 1px solid #eeeeee;"></div>

          <img class="con_images"
               :src="item.vPicUrl"
               alt
               v-if="item.vPicUrl" />
          <img class="con_images"
               :src="item.vViewUrl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast'"
               alt
               v-else />
          <!--<img class="con_images" src="../../assets/images/default.png" alt="" v-else>-->
          <div class="text_desc">
            <p class="item_title">{{item.vTitle}}</p>
            <div class="item_text">
              <p>{{item.vSpeaker}}</p>
              <p>{{item.teacher?item.teacher.tOrg:''}}</p>
            </div>
          </div>
        </div>
        <div class="num_type"
             v-if="activeTab==2">
          <p>
            <img src="../../assets/images/graysee.png"
                 class="see"
                 alt />
            <span>{{item.vViewCount}}人观看</span>
          </p>
          <p>
            <img src="../../assets/images/graylesson.png"
                 class="lesson"
                 alt />
            <span>
              <span v-if="item.vIsPublic==0">非</span>公开课
            </span>
          </p>
        </div>
      </div>

      <p class="end"><span> </span> THE END <span> </span></p>
      <!-- <p>{{item.teacher?item.teacher.tOrg:''}}</p> -->
    </div>
    <div class="none"
         v-else>
      <img src="../../assets/images/none.png"
           alt="">
      <p>暂无收藏</p>
    </div>

  </div>
</template>
<script>
import iVideolist from '../container/videoList'
import loginService from '../../plugin/extendFn/loginService'
import AppSetting from '../../AppSetting'
export default {
  data () {
    return {
      activeTab: 2,
      allData: null,
      containerList: [],//直播列表内容
      wxuser: null,
    }
  },
  props: {},
  methods: {
    toDetails (item) {
      if (this.activeTab == 1) {
        this.$router.push({
          name: 'colDetails',
          query: {
            type: 'column',
            colId: item.vId

          }
        })
      } else {
        this.$router.push({
          name: 'vDetails',
          query: {
            type: 'video',
            videoId: item.vId

          }
        })

      }


    },
    tab (val) {
      this.activeTab = val;

      if (this.allData) {
        if (val == 1) {
          let arr = [];

          this.allData.columnList.map(item => {
            let obj = {
              vTitle: item.colTitle,
              vSpeaker: '',
              teacher: '',
              vViewCount: '',
              vIsPublic: '',
              vFl: item.colFl,
              vPicUrl: item.colThumbnailUrl,
              vId: item.colId,
            }
            arr.push(obj)
          })
          this.containerList = arr

        } else {
          this.containerList = this.allData.list
        }

      }


    },
    getTimes (value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    getList () {
      this.$postHttp(AppSetting.baseUrl + '/student/collection', { id: this.wxuser.uId }).then((res) => {
        if (res.data.code == 0) {
          this.allData = res.data

          this.containerList = res.data.list;
          this.tab(this.activeTab)
        }
      })
    }
  },
  computed: {},
  components: {
    iVideolist
  },

  async  mounted () {
    this.wxuser = await loginService.getLoginUser();

    this.getList();
    document.title = '我的收藏'
  },
  activated () {
    if (this.$route.meta.keepAliveChange) {
      this.getList();
    }
    document.title = '我的收藏'
  },
}
</script>
<style scoped lang="scss">
.collectWrap {
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  overflow: hidden;
}
.tab {
  width: 100%;
  display: flex;
  font-size: 0.3rem;
  color: #333;
  text-align: center;
  line-height: 0.8rem;
  background: #fff;
  padding: 0px 0.3rem;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  span {
    flex: 1;
    padding: 0px 0.15rem;
    box-sizing: border-box;
  }
}
.activeTab {
  color: #05a2ff;
  font-size: 0.34rem;
  border-bottom: 0.01rem solid #05a2ff;
}
.none {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-top: 2.64rem;
  box-sizing: border-box;
  img {
    width: 100%;
  }
  p {
    font-size: 0.38rem;
    color: #666666;
    text-align: center;
  }
}
.container {
  background: #f4f5f4;
  min-height: 100vh;
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  flex-grow: 0;
  overflow-y: scroll;
  /*margin-bottom: 1.18rem;*/

  .end {
    text-align: center;
    color: #dbdbdb;
    font-size: 0.22rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.33rem;
    span {
      display: inline-block;
      overflow: hidden;
      width: 1rem;
      vertical-align: center;
      border-top: 1px solid #dbdbdb;
    }
    span:nth-of-type(1) {
      margin-right: 0.18rem;
    }
    span:nth-of-type(2) {
      margin-left: 0.18rem;
    }
  }
}
.container_item {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  background: #ffffff;
  width: 6.9rem;
  // height: 2.6rem;
  border-bottom: 0;
  margin-bottom: 0.2rem;

  .item_con {
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    padding: 0.2rem 0.2rem;
    box-sizing: border-box;
    position: relative;
    .text_desc {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 1.6rem;
    }
    img {
    }
    .item_title {
      width: 3.47rem;
      font-size: 0.28rem;
      font-weight: bold;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2;
      line-height: 0.42rem;
      color: #333333;
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
    .item_text {
      color: #333333;
      p {
        font-size: 0.26rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 3.47rem;
        /*line-height: 0.68rem;*/
        /*height: 0.25rem;*/
      }
    }
  }
  .num_type {
    font-size: 0.24rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    p {
      width: 3.44rem;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.28rem;
      color: #666666;
    }
    img {
      margin-right: 0.2rem;
    }
    .see {
      width: 0.4rem;
    }
    .lesson {
      width: 0.4rem;
    }
    p:nth-of-type(1) {
      border-right: 1px solid #e6e6e6;
    }
  }
}
.con_images {
  border: 1px solid #eeeeee;
  width: 2.84rem;
  height: 1.6rem;
  margin-right: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/me/collection.vue